export const PAGINATION_PER_PAGE_CHOICES = [10, 25, 50]
export const PAGINATION_PER_PAGE = 50
